module.exports = __webpack_public_path__ + "static/media/h3.7c1330ff.jpg";